function setAccordionItemOpen( itemEl, shouldOpen ) {
	const button = itemEl.querySelector( '.accordion-button' );
	const collapse = itemEl.querySelector( '.accordion-collapse' );

	if ( ! button || ! collapse ) {
		return;
	}

	if ( shouldOpen ) {
		button.classList.remove( 'collapsed' );
		button.setAttribute( 'aria-expanded', 'true' );
		collapse.classList.add( 'show' );
	} else {
		button.classList.add( 'collapsed' );
		button.setAttribute( 'aria-expanded', 'false' );
		collapse.classList.remove( 'show' );
	}
}

document.addEventListener( 'click', function ( event ) {
	const toggle = event.target.closest( '[data-accordion-toggle]' );
	if ( ! toggle ) {
		return;
	}

	const action = toggle.getAttribute( 'data-accordion-toggle' );
	if ( ! action ) {
		return;
	}

	const wrapper = toggle.closest( '.wp-block-snl-accordion-wrapper' );
	if ( ! wrapper ) {
		return;
	}

	const items = wrapper.querySelectorAll( '.accordion-item' );
	if ( ! items.length ) {
		return;
	}

	const open = action === 'open-all';
	items.forEach( function ( item ) {
		setAccordionItemOpen( item, open );
	} );

	event.preventDefault();
} );
